import { initialCommunicationState } from 'shared/constants';
import { ReduxState } from '../types/ReduxState';

export const initialState: ReduxState = {
  communication: {
    downloadingFile: initialCommunicationState,
  },
};
